import React from "react";
import Story from "./Story";
import "../css/StoryReel.css";

function StoryReel() {
  return (
    <div className="storyReel">
      <Story
        image="https://hatrabbits.com/wp-content/uploads/2016/12/rare-combinaties.jpg"
        profileSrc="http://bank-space.com/portfolio/images/about_me_img.png"
        title="Tiger Bank"
      />
      <Story
        image="https://hatrabbits.com/wp-content/uploads/2016/12/rare-combinaties.jpg"
        profileSrc="http://bank-space.com/portfolio/images/about_me_img.png"
        title="Tiger Bank"
      />
      <Story
        image="https://hatrabbits.com/wp-content/uploads/2016/12/rare-combinaties.jpg"
        profileSrc="http://bank-space.com/portfolio/images/about_me_img.png"
        title="Tiger Bank"
      />
      <Story
        image="https://hatrabbits.com/wp-content/uploads/2016/12/rare-combinaties.jpg"
        profileSrc="http://bank-space.com/portfolio/images/about_me_img.png"
        title="Tiger Bank"
      />
      <Story
        image="https://hatrabbits.com/wp-content/uploads/2016/12/rare-combinaties.jpg"
        profileSrc="http://bank-space.com/portfolio/images/about_me_img.png"
        title="Tiger Bank"
      />
    </div>
  );
}

export default StoryReel;
